<div class="form-group input-group form-floating mt-4-plus mt-md-5 d-flex">
  <input type="text"
         #dateInput
         class="form-control datepicker"
         placeholder="{{'General.DatePlaceholder' | translate}}"
         bsDatepicker
         #dp="bsDatepicker"
         [formControl]="control"
         [bsConfig]="bsConfig"
         [required]="required"
         (click)="onInputClick($event)"
         [ngClass]="{
        'has-tooltip': toolTipMessage,
        'is-invalid': control.invalid && (control.dirty || control.touched),
        'is-valid': (required ? (control.valid && (control.dirty || control.touched) && control.value !== '') : (control.value !== '' && (control.dirty || control.touched))),
        'ng-untouched': !control.touched,
        'ng-pristine': !control.dirty,
        'custom-valid': (required ? (control.valid && control.value !== '') : control.value !== ''),
        'ng-invalid': control.invalid
         }"
         readonly>

  <label *ngIf="label" for="text-{{htmlId}}">
    {{ label }}
  </label>
  <span class="input-group-text calender-icons-wrap" [ngClass]="{'border-success' : !error && control.touched && (required ? (control.valid && control.value) : control.value)}" (click)="openDatepicker()">
    <ng-container *ngIf="!error && (!control.touched || !control.value)">
      <i class="fa-regular fs-5 fa-calendar-days"></i>
    </ng-container>
    <ng-container *ngIf="error">
      <i class="fa-solid fs-5 text-warning fa-calendar-xmark"></i>
    </ng-container>
    <ng-container *ngIf="!error && control.touched && (required ? (control.valid && control.value) : control.value)">
      <i class="fa-solid fs-5 text-success fa-calendar-check"></i>
    </ng-container>
  </span>

  <ng-container *ngIf="toolTipMessage">
    <div class="align-self-center ps-3">
      <i class="fa-solid fa-circle-question text-warning fs-3" [tooltip]="toolTipMessage"
         container="align-self-center"
         placement="auto"></i>
    </div>
  </ng-container>

  <ng-container *ngIf="error">
    <div class="error-message text-warning ps-2">
      {{ errorMessage }}
    </div>
  </ng-container>
</div>
